import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { apiGetActions } from '@app/react/action';
import type { GetResponseOrderParts, GetResponseFamilyCrestColors } from '@app/react/const/type';

export interface IProductOrderParts {
    shaft: GetResponseOrderParts | null;
    hane: GetResponseOrderParts | null;
    thread: GetResponseOrderParts | null;
    nock: GetResponseOrderParts | null;
    kebiki: GetResponseOrderParts | null;
    arrowinsert: GetResponseOrderParts | null;
    unit: GetResponseOrderParts | null;
    arrowhead: GetResponseOrderParts | null;
    arrowlength: GetResponseOrderParts | null;
    twine: GetResponseOrderParts | null;
    lame: GetResponseOrderParts | null;
    carving: GetResponseOrderParts | null;
    familycrest: GetResponseOrderParts | null;
    familycrestColor: GetResponseFamilyCrestColors | null;
    typezero: GetResponseOrderParts | null;
    decoration: GetResponseOrderParts | null;
    featherinside: GetResponseOrderParts | null;
}

const initStateGetResponseOrderParts: IProductOrderParts = {
    shaft: null,
    hane: null,
    thread: null,
    nock: null,
    kebiki: null,
    arrowinsert: null,
    unit: null,
    arrowhead: null,
    arrowlength: null,
    twine: null,
    lame: null,
    carving: null,
    familycrest: null,
    familycrestColor: null,
    typezero: null,
    decoration: null,
    featherinside: null,
};

export const APIDataGetReducer = reducerWithInitialState(
    initStateGetResponseOrderParts,
)
    .case(apiGetActions.shaft.done, (state, action) => {
        const { param: shaft } = action.result;

        return {
            ...state,
            shaft,
        };
    })
    .case(apiGetActions.feather.done, (state, action) => {
        const { param: hane } = action.result;

        return {
            ...state,
            hane,
        };
    })
    .case(apiGetActions.thread.done, (state, action) => {
        const { param: thread } = action.result;

        return {
            ...state,
            thread,
        };
    })
    .case(apiGetActions.kebiki.done, (state, action) => {
        const { param: kebiki } = action.result;

        return {
            ...state,
            kebiki,
        };
    })
    .case(apiGetActions.nock.done, (state, action) => {
        const { param: nock } = action.result;

        return {
            ...state,
            nock,
        };
    })
    .case(apiGetActions.arrowhead.done, (state, action) => {
        const { param: arrowhead } = action.result;

        return {
            ...state,
            arrowhead,
        };
    })
    .case(apiGetActions.arrowlength.done, (state, action) => {
        const { param: arrowlength } = action.result;

        return {
            ...state,
            arrowlength,
        };
    })
    .case(apiGetActions.unit.done, (state, action) => {
        const { param: unit } = action.result;

        return {
            ...state,
            unit,
        };
    })
    .case(apiGetActions.arrowinsert.done, (state, action) => {
        const { param: arrowinsert } = action.result;

        return {
            ...state,
            arrowinsert,
        };
    })
    .case(apiGetActions.twine.done, (state, action) => {
        const { param: twine } = action.result;

        return {
            ...state,
            twine,
        };
    })
    .case(apiGetActions.lame.done, (state, action) => {
        const { param: lame } = action.result;

        return {
            ...state,
            lame,
        };
    })
    .case(apiGetActions.carving.done, (state, action) => {
        const { param: carving } = action.result;

        return {
            ...state,
            carving,
        };
    })
    .case(apiGetActions.familycrest.done, (state, action) => {
        const { familycrest, familycrestColor } = action.result;

        return {
            ...state,
            familycrest,
            familycrestColor,
        };
    })
    .case(apiGetActions.typezero.done, (state, action) => {
        const { param: typezero } = action.result;
        return {
            ...state,
            typezero,
        };
    })
    .case(apiGetActions.decoration.done, (state, action) => {
        const { param: decoration } = action.result;

        return {
            ...state,
            decoration,
        };
    })
    .case(apiGetActions.featherinside.done, (state, action) => {
        const { param: featherinside } = action.result;

        return {
            ...state,
            featherinside,
        };
    });
